import dynamic from 'next/dynamic'
import React from 'react'
import type { LottieProps } from 'react-lottie'

const Lottie = dynamic(() => import('react-lottie'))

const ExpandableCard = ({
  title,
  description,
  expandImage,
  animationProp
}: {
  title: string
  description: string
  expandImage: string
  animationProp: LottieProps
}) => {
  return (
    <div className="my-12 mx-4 flex flex-col sm:flex-row items-center bg-zinc-800 rounded-2xl overflow-hidden relative">
      <div className="px-6 py-14 sm:w-96 flex flex-col items-center justify-center h-full">
        <div className="h-24 w-24 rounded">
          <Lottie {...animationProp} />
        </div>
        <h2 className="text-3xl mt-6 mb-2">{title}</h2>
        <p className="text-center text-primary-light">{description}</p>
      </div>

      <div className="bg-zinc-700 py-6">
        <img
          alt="animation card"
          src={expandImage}
          className="h-full w-full object-contain object-center"
        />
      </div>
    </div>
  )
}

export default ExpandableCard
